import { atomWithStorage } from "jotai/utils";

import { webStorageConfig } from "@/config/web-storage";

export const sidebarCollapsedAtom = atomWithStorage<boolean>(
  webStorageConfig.sidebarCollapsed.key,
  false,
  undefined,
  { getOnInit: true }
);
